<script>
    import { createEventDispatcher } from "svelte";

    export let position = 0;

    const dispatch = createEventDispatcher();

    function handleDragStart(event) {
        // Prevent the parent container's mousedown event from also firing
        event.stopPropagation();
        // Dispatch a custom event named 'seekstart' to the parent component,
        // passing along the original browser event.
        dispatch("seekstart", event);
    }
</script>

<div
    aria-label="Seek audio position"
    on:mousedown={handleDragStart}
    on:touchstart={handleDragStart}
    class="cursor absolute top-0 h-full w-2 bg-red-500 drop-shadow-2xl shadow-black shadow-inner select-none"
    style="left: {position}%;"
>
</div>

<style>
    .cursor {
        transition-property: left;
        transition-duration: 100ms;
    }
</style>
